import { isInApp, uploadTrackings } from '@docs/common'
import { uploadTrackingEvents } from './request'
import qs from 'qs'
import { getLanguae, getSearchCountry } from './util'
import { v4 as uuidV4 } from "uuid"
import Cookies from 'js-cookie'
import { sensors } from './sensors'

const SA_EVENT_MAP: Record<number, string> = {
  400038: 'tutorial_web_guide_page_view',
  400024: 'tutorial_web_navigation_tab_click',
  400025: 'tutorial_web_navigation_module_click',
  400020: 'tutorial_web_navigation_video_play',
  10001:  'tutorial_web_solution_page_view',
  10002:  'tutorial_web_solution_page_loading',
  10003:  'tutorial_web_solution_page_leave',
  10100:  'tutorial_web_solution_sku_click',
  10004:  'tutorial_web_solution_sku_expose',
  400008: 'tutorial_web_solution_like',
  400007: 'tutorial_web_solution_unlike',
  400045: 'tutorial_web_solution_link_click',
  400044: 'tutorial_web_solution_video_play',
  400010: 'tutorial_web_solution_reply',
  400039: 'tutorial_web_detail_page_view',
  400013: 'tutorial_web_detail_button_click',
  400014: 'tutorial_web_detail_back',
  400015: 'tutorial_web_detail_view_percent',
  400016: 'tutorial_web_detail_like',
  400017: 'tutorial_web_detail_unlike',
  400018: 'tutorial_web_detail_links_sheet',
  400019: 'tutorial_web_detail_link_click',
  400043: 'tutorial_web_detail_see_all',
  400046: 'tutorial_web_category_page_duration',
  400040: 'tutorial_web_quick_page_view',
  400041: 'tutorial_web_quick_page_click',
  400042: 'tutorial_web_quick_page_duration',
}
// start_ai_generated
// 尝试解析 extra 字符串为 JSON
function parseJSON(jsonString: string) {
  try {
    return JSON.parse(jsonString)
  } catch (error) {
    // 如果解析失败，返回空对象
    return {}
  }
}
// end_ai_generated

const getBrowserId = (): string => {
  let browserId = localStorage.getItem('browserId');
  if (!browserId) {
    browserId = uuidV4();
    localStorage.setItem('browserId', browserId);
  }
  return browserId;
};

const track = async (type: number, value: string, extra?: string) => {
  const { app } = qs.parse(window.location.search, { ignoreQueryPrefix: true })
  const extraParse = parseJSON(extra || '{}')
  // 由于language country目前上报的是在请求头上的，为了简单所以统一放在extra上，大数据那边取值
  const extraObj = {
    id: extraParse.id || value,
    appName: app,
    ab_code: getSearchCountry(), //country
    language: extraParse?.language || getLanguae(),
    module: extraParse?.module || 'tutorial',
    ...extraParse,
  }
  if (await isInApp()) {
    uploadTrackings({
      events: [
        {
          type: String(type),
          extra: JSON.stringify({ ...extraObj, appName: Cookies.get('app_name')?.replace(/_/g, '-') || app, source: 'App' }),
          value: value,
          ts: parseInt((Date.now() / 1000).toString()),
        },
      ],
    })
  } else {
    // 使用 parseJSON 函数解析 extra 并合并其他属性
    // c6ef73953b4492a8840293e78b59887be28deac6
    uploadTrackingEvents({
      events: [
        {
          type: String(type),
          extra: JSON.stringify({ ...extraObj, source: 'Web' }),
          value: value,
          ts: parseInt((Date.now() / 1000).toString()),
          session_id: getBrowserId()
        },
      ],
    }).then(res => {
      console.log('uploadTrackingEvents', {
        type: String(type),
        extra: JSON.stringify(extraObj),
        value: value,
        ts: parseInt((Date.now() / 1000).toString()),
        session_id: getBrowserId()
      })
    })
  }

  const saEventName = SA_EVENT_MAP[type] ?? `Event_${type}`
  const { appName, id, ...extraObjRest } = extraObj
  sensors.track(saEventName, { ...extraObjRest, content_id: id, app_line: appName })
}

// Guide访问页面
export const trackGuidePageView = (id: number | string, pn: string, language: string) => {
  track(400038, String(id), JSON.stringify({ pn, language, module: 'tutorial-guide' }))
}

// 导航页点击tab 上报
export const trackNavigationTabClick = (id: number | string, title: string, pn: string, language: string) => {
  track(400024, String(title), JSON.stringify({ id, pn, title, language, module: 'tutorial-guide' }))
}

// 导航页各个模块的点击上报
export const trackNavigationModuleClick = (
  title: string,
  extra: { id: string | number; module: string; value: string; language?: string; pn?: string; sub_module?: string }
) => {
  track(400025, title, JSON.stringify({ ...extra, module: 'tutorial-guide' }))
}

// 导航页各个模块的点击上报
export const trackNavigationVideoPlay = (
  duration: number,
  vid: string,
  id: number,
  pn?: string,
  language?: string,
  sub_module?: string
) => {
  track(400020, String(duration), JSON.stringify({ vid, id, pn, language, sub_module, module: 'tutorial-guide' }))
}

// solution页面访问上报
export const trackViewSolutionPage = (id: number | string, module: string, duration: number) => {
  track(10001, String(id), JSON.stringify({ module, duration }))
}

// solution页面loding访问上报
export const trackViewSolutionPageloading = (id: number | string, module: string, duration: number) => {
  track(10002, String(id), JSON.stringify({ module, duration }))
}

//solution 离开页面访问上报
export const trackLeaveSolutionPage = (
  id: number | string,
  module: string,
  message: number | string,
  duration: number
) => {
  track(10003, String(id), JSON.stringify({ module, message, duration }))
}

// solution页面点击sku访问上报
export const trackClickSolutionSku = (id: number | string, name: string, sku: string) => {
  track(10100, String(id), JSON.stringify({ name, sku }))
}

// solution页面完犊率
export const trackExposeSolutionSku = (id: number | string, sku: string) => {
  track(10004, String(id), JSON.stringify({ sku, module: 'SolutionArticle' }))
}

// solution页点赞上报
export const trackUpdateLikeSolution = (id: number | string, sub_module: string, name: string) => {
  track(400008, String(id), JSON.stringify({ name, sub_module }))
}

// solution页取消点赞上报
export const trackUnLikeSolution= (id: number | string, sub_module: string, name: string) => {
  track(400007, String(id), JSON.stringify({ name, sub_module }))
}

// solution页面点击评论icon上报
export const trackFeedbackSolution = (id: number | string, name: string, sku: string) => {
  track(10100, String(id), JSON.stringify({ name, sku }))
}

// solution点击页面链接上报
export const trackSolutionLinkPage = (id: number | string, href: string) => {
  track(400045, String(href), JSON.stringify({ id, module: 'SolutionArticle' }))
}

// solution点击页面video上报
export const trackSolutionVideoPage = (id: number | string, url: string) => {
  track(400044, String(url), JSON.stringify({ id, module: 'SolutionArticle' }))
}

// solution回车键回复上报
export const trackEnterSolutionPage= (id: number | string, content: string) => {
  track(400010, String(id), JSON.stringify({ content }))
}

// 详情页访问页面
export const trackDetailPageView = (id: number | string, pn: string) => {
  track(400039, String(id), JSON.stringify({ pn, module: 'tutorial-document' }))
}

// 详情页按钮点击上报
export const trackDetailButton = (id: number | string, title: string, entry_id?: number | string) => {
  track(400013, String(id), JSON.stringify({ title, entry_id, module: 'tutorial-document' }))
}

// 详情页返回按钮点击上报
export const trackDetailBack = (id: number | string) => {
  track(400014, String(id), JSON.stringify({ module: 'tutorial-document' }))
}

// 详情页浏览进度上报
export const trackDetailViewPercent = (id: number | string, percent: string) => {
  track(400015, percent, JSON.stringify({ id: String(id), module: 'tutorial-document' }))
}

// 详情页点赞上报
export const trackDetailLike = (id: number | string) => {
  track(400016, String(id), JSON.stringify({ module: 'tutorial-document' }))
}

// 详情页点赞上报
export const trackDetailUnLike = (id: number | string) => {
  track(400017, String(id), JSON.stringify({ module: 'tutorial-document' }))
}

// 详情页展开links上报
export const trackDetailLinksSheet = (id: number | string) => {
  track(400018, String(id), JSON.stringify({ module: 'tutorial-document' }))
}

// 详情页展开link点击上报
export const trackDetailLinkClick = (id: number | string, title: string) => {
  track(400019, String(id), JSON.stringify({ title: title, module: 'tutorial-document' }))
}

// 点击see all上报
export const trackDetailSeeAll = (id: number | string, title: string, pn: string, language: string) => {
  track(400043, String(title), JSON.stringify({ id, pn, language, module: 'tutorial-guide', sub_module: title }))
}

// see all访问页面
export const trackCategoriesPageView = (id: number | string, title: string, language: string, sub_module: string) => {
  track(
    400044,
    String(title),
    JSON.stringify({ id, language, module: 'tutorial-catagory_page', sub_module: sub_module })
  )
}

// see all点击页面
export const trackCategoriesPageClick = (title: string, id?: number | string, language?: string, sub_module?: string) => {
  track(
    400045,
    String(title),
    JSON.stringify({ id, language, module: 'tutorial-catagory_page', sub_module: sub_module })
  )
}

// see all页面停留时长
export const trackCategoriesPageDuration = (
  id: number | string,
  language?: string,
  sub_module?: string,
  duration?: number | string
) => {
  track(
    400046,
    String(duration),
    JSON.stringify({ id, language, module: 'tutorial-catagory_page', sub_module: sub_module })
  )
}

// 五码合一页面访问
export const trackQuickPageView = (id: number | string, title: string, pn: string) => {
  track(
    400040,
    String(title),
    JSON.stringify({ id, pn,module: 'tutorial-quick_start'})
  )
}

// 五码合一页面点击
export const trackQuickPageClick = (title: string, pn: string) => {
  track(
    400041,
    String(title),
    JSON.stringify({ pn, module: 'tutorial-quick_start'})
  )
}

// 五码合一页面停留时长
export const trackQuickPageDuration = (
  id: number | string,
  pn: string,
  duration: number | string
) => {
  track(
    400042,
    String(duration),
    JSON.stringify({ id, pn, module: 'tutorial-quick_start' })
  )
}
